import { type BlockSteps, type FsmDefDoBotState } from "@do/shared-types";
import { useEffect } from "react";
import { useChat } from "../../../../providers/chat-provider";

type MessageStepDoBotProps = {
  action: FsmDefDoBotState["meta"]["action"];
  label?: BlockSteps["label"];
  payload: string;
  solLabelId?: BlockSteps["sol_label_id"];
};

export const MessageStepDoBot = ({ action, label, payload, solLabelId }: MessageStepDoBotProps) => {
  const { onFastAction } = useChat();

  useEffect(() => {
    // Empty action is a no-op (e.g. form success screen without a bot call).
    if (!action.trim()) return;

    onFastAction({
      // The block's solution, reported apart (`/sol_clicked`): a second entry, since the first
      // one is all that goes with the action itself.
      metadata: [{ form: payload }, { sol_label_id: solLabelId, sol_title: label }],
      payload: `/${action}`,
      title: "",
    });
  }, [action, label, onFastAction, payload, solLabelId]);

  return null;
};
